import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next'
import configData from '../../../temp/config';
import './search-type-drop-down.css';

const SearchTypeDropdown = (props) => {

    const [showItems, setShowItems] = useState(false)
    const [defaultSearchType, setDefaultSearchType] = useState(props.searchTypes[0].fields.name.value)
    const { t } = props;

    useEffect(() => {
        // document.addEventListener('click', handleClickOutside);
        props.getSearchType(props.searchTypes[0].fields)
    },[])

    const handleClickOutside = (event) => {
        console.log(event.target.className)
        if (event.target.className === 'select-box--selected-item' && document.getElementsByClassName('select-box--arrow-down')[0] !== undefined) {
            setShowItems(true)
        }
        else if (event.target.className === 'select-box--arrow-down') {
            setShowItems(false)
        }
        else if (event.target.className === 'select-box--arrow-up') {
            setShowItems(true)
        } else {
            setShowItems(false)
        }
        // if(event.target.className === 'select-box--selected-item opened') setShowItems(true)

    }

    const dropDown = () => {
        showItems ? setShowItems(false) : setShowItems(true)
    }

    const closeDropDown = () => {
        setShowItems(false)
    }

    const selectItem = (item) => {
        setDefaultSearchType(item.fields.name.value)
        setShowItems(false)
        props.getSearchType(item.fields)
        props.setWarningMessage(false)
        // props.paginate(1)
        sessionStorage.setItem('currentPage', 1)
    }

    return (
        <div className="nameSearchFieldDropdown">
            <div className="custom-select-dropdown">
               
                    <div className="select-box--box">
                        <div className="select-box--container"  >
                        <div className={"select-box--selected-item"} onClick={dropDown}>
                                <div className="slect-box-selected-item-text-div" >
                                <span className="slect-box-selected-item-text">{defaultSearchType}</span>
                                </div>
                                <div className="select-box--arrow" name="select-box--name">
                                <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>
                                </span>
                            </div>
                            </div>
                            {/* <div className="select-box--arrow" name="select-box--name" onBlur={closeDropDown}>
                                <span name="drop-down-arrow" className={`${showItems ? 'select-box--arrow-up fa fa-angle-up' : 'select-box--arrow-down fa fa-angle-down'}`}>
                                </span>
                            </div> */}
                            <div style={{ display: showItems ? 'block' : 'none' }}
                                className="select-box--items"
                            >
                                {
                                    props.searchTypes.map((item, index) => {
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => selectItem(item)}
                                                className={defaultSearchType === item.fields.name.value ? 'selected' : ''}
                                            ><p className="nameListItem">
                                                    {item.fields.name.value}
                                                </p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
              
            </div>
        </div>
    )
};

export default withTranslation()(SearchTypeDropdown);